import { LeadStatus } from '@40seas/entities/leads';
import { EnumColor } from '@40seas/frontend/common/providers';

export const leadsStatusColorMapping = {
    [LeadStatus.Pending]: 'default',
    [LeadStatus.InProgress]: 'info',
    [LeadStatus.Churned]: 'error',
    [LeadStatus.SignedUp]: 'success',
    [LeadStatus.Disqualified]: 'info',
} as { [key in LeadStatus]: EnumColor };
